// extracted by mini-css-extract-plugin
export default {"recos":"j6-z","productCardOverride":"k6-z","rowHasBadge":"l6-z"};